(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["t4-dobavi-vednazh"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Двойно докосване на „Добави“ (продукт, карта, плочка с грамаж, картите на въпросника): второто подаване тръгва, докато
       първото още зарежда - браузърът прекъсва първата заявка, но магазинът вече я е изпълнил, и в количката влизат 2 бройки
       (поток C, S4 на Android). Всяка форма към /cart/add се подава веднъж; пак може след 8 s (ако страницата не си е
       тръгнала - няма мрежа, спряно зареждане), а „Назад“ (pageshow) го позволява веднага. На document в capture - преди
       слушателите на Shopify върху формата; хваща и формите, дорисувани след зареждането. „Друг грамаж“ на продукта не се
       пипа: той праща сам (fetch), заключва бутона си и при неуспех трябва да може веднага пак - после вика t4Dobaveno отдолу. */
    var podadeni = new WeakMap();
    /* кутията и гласът се търсят при нужда, не при зареждане - кодът може да тръгне преди края на страницата */
    function kutia() { return document.querySelector('[data-t4-dobaveno]'); }
    function glas() { return document.querySelector('[data-t4-dobaveno-glas]'); }
    function tekst(ime, rezerva) { var g = glas(); return (g && g.getAttribute(ime)) || rezerva; }

    function skrii() { var k = kutia(); if (k) k.hidden = true; }

    /* Броят в хедъра - както snippets/t4-broy-kolichka: редът „По грамаж“ е ЕДИН артикул (количеството му е десетки грамове) */
    function obnoviBroya() {
      window.fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (o) { return o.json(); })
        .then(function (k) {
          var broy = 0;
          (k.items || []).forEach(function (r) { broy += r.variant_title === 'По грамаж' ? 1 : r.quantity; });
          var vrazka = document.querySelector('.t4-ikona--kolichka');
          if (!vrazka) return;
          var znak = vrazka.querySelector('.t4-kolichka-broy');
          if (!znak && broy > 0) {
            znak = document.createElement('span');
            znak.className = 't4-kolichka-broy t4-chislo';
            znak.setAttribute('aria-hidden', 'true');
            vrazka.appendChild(znak);
          }
          if (znak) znak.textContent = String(broy);
        })
        .catch(function () { /* броят се оправя при следващото зареждане */ });
    }

    /* Кутията под хедъра: заглавие и какво е добавено; при грешка - текстът на магазина (например „всички налични са в
       количката“). Не се затваря сама - затваря се с „Продължи“, Esc или клик извън нея. */
    function pokazhi(ime, opis, greshka) {
      var k = kutia();
      if (!k) return;
      var z = k.querySelector('[data-t4-dobaveno-zaglavie]');
      var n = k.querySelector('[data-t4-dobaveno-ime]');
      if (!z.hasAttribute('data-osnoven')) z.setAttribute('data-osnoven', z.textContent);
      z.textContent = greshka || z.getAttribute('data-osnoven');
      n.textContent = greshka ? '' : [ime, opis].filter(Boolean).join(' · ');
      k.classList.toggle('t4-dobaveno--greshka', !!greshka);
      var hedar = document.querySelector('.t4-hedar');
      var dolu = hedar ? hedar.getBoundingClientRect().bottom : 0;
      k.style.top = Math.max(8, Math.round(dolu) + 8) + 'px';
      k.hidden = false;
      var g = glas();
      if (g) g.textContent = greshka ? greshka : z.textContent + ': ' + n.textContent;
    }

    /* за „Друг грамаж“ на продукта (sections/t4-produkt.liquid) - той добавя сам и вика това с името и сметката */
    window.t4Dobaveno = function (ime, opis) {
      pokazhi(ime, opis, null);
      obnoviBroya();
    };

    /* какво е добавено - от отговора на /cart/add.js и от формата (бройката, която е поискана, не общата на реда) */
    function opisNa(red, poiskano) {
      if (!red) return '';
      if (red.variant_title === 'По грамаж') return poiskano * 10 + ' ' + tekst('data-merka', 'гр.');
      var izh = [];
      if (red.variant_title && !red.product_has_only_default_variant) izh.push(red.variant_title);
      if (poiskano > 1) izh.push('× ' + poiskano);
      return izh.join(' ');
    }

    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.getAttribute || (f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (f.querySelector('[data-drug-gramazh]:checked')) return;
      var t = podadeni.get(f);
      if (t && Date.now() - t < 8000) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }
      podadeni.set(f, Date.now());

      /* добавяне без излизане от страницата; на самата количка - старият път, за да се презареди списъкът и прозорецът */
      if (!window.fetch || !window.FormData || !kutia() || /\/cart\/?$/.test(location.pathname)) return;
      e.preventDefault();
      var danni = new FormData(f);
      var poiskano = Math.max(1, parseInt(danni.get('quantity'), 10) || 1);
      var buton = e.submitter || null;
      if (buton) buton.disabled = true;
      /* window.fetch - взет сега, не по-рано: обвивката на Shopify за статистиката се слага след зареждането */
      window.fetch(f.getAttribute('action').replace(/\/cart\/add\/?$/, '/cart/add.js'), {
        method: 'POST',
        body: danni,
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      }).then(function (o) {
        return o.json().then(function (j) { return { ok: o.ok, j: j }; });
      }).then(function (x) {
        podadeni.delete(f);
        if (buton) buton.disabled = false;
        if (!x.ok) {
          pokazhi(null, null, (x.j && (x.j.description || x.j.message)) || tekst('data-greshka', ''));
          return;
        }
        var red = x.j && x.j.items ? x.j.items[0] : x.j;
        pokazhi(red && red.product_title, opisNa(red, poiskano), null);
        obnoviBroya();
      }).catch(function () {
        podadeni.delete(f);
        if (buton) buton.disabled = false;
        pokazhi(null, null, tekst('data-greshka', ''));
      });
    }, true);
    window.addEventListener('pageshow', function () { podadeni = new WeakMap(); });

    document.addEventListener('click', function (e) {
      var k = kutia();
      if (!k || k.hidden) return;
      if (e.target.closest && e.target.closest('[data-t4-dobaveno-zatvori]')) { skrii(); return; }
      /* клик извън кутията я затваря; кликът по „Добави“ - не (той показва нова) */
      if (!k.contains(e.target) && !(e.target.closest && e.target.closest('form[action*="/cart/add"], [form="t4-forma-kupi"]'))) skrii();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') skrii(); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["t4-validacia"] && !Shopify.designMode) return;
  try {
    /* Кога браузърът показва балон: при изпращане на форма с невалидно поле („Добави“, „Обнови“, бюлетинът, „Уведоми ме“) и
     при reportValidity() („Към плащане“ проверява „Брой“ - assets/t4-faktura.js). Преди балона браузърът праща събитие
     „invalid“ на полето; тогава тук се слага setCustomValidity с нашия текст и балонът го показва.
     · Решава се на самото поле, след слушателите на страницата върху формата: ако страницата е отказала балона
       (preventDefault - фактурата в количката показва свои съобщения под полетата), тук не се слага нищо.
     · Поле с чуждо съобщение (setCustomValidity от друг скрипт) не се пипа; прозорецът на Изпрати.БГ - също.
     · Нашето съобщение държи полето невалидно, докато не го махнем - затова след всяко въвеждане (и след скриптовете на
       страницата, които закръглят стойността) се сверява наново, а преди клик на бутон за изпращане се маха изобщо: при
       проверката браузърът пак праща „invalid“ и, ако полето още е невалидно, текстът се слага отново. Така проверката
       дава същото, което би дала без този код - сменя се само текстът. */
  var izvor = document.getElementById('t4-validacia');
  var T = null;
  try { T = izvor ? JSON.parse(izvor.textContent) : null; } catch (greshka) { T = null; }
  if (T) {
    var nashi = new Set();   // полетата с наше съобщение в момента
    var CHISLO = typeof Intl !== 'undefined' ? new Intl.NumberFormat('bg-BG') : null;   // 10 000
    var chislo = function (x) { return CHISLO && isFinite(x) ? CHISLO.format(x) : String(x); };
    var tekst = function (kluch, chisla) {
      return String(T[kluch] || '').replace(/\{(\w+)\}/g, function (m, ime) { return chisla && ime in chisla ? chisla[ime] : m; });
    };
    // „Брой“ (продуктът, количката) и грамажът на „Друг грамаж“ имат свои текстове; другите числови полета - общите
    var vid = function (pole) {
      if (pole.name === 'quantity' || pole.name === 'updates[]') return 'broy';
      if (pole.hasAttribute('data-pg-obshto') || pole.hasAttribute('data-pg-po')) return 'gramove';
      return '';
    };
    var saobshtenie = function (pole) {
      var v = pole.validity;
      if (v.badInput) return tekst('chislo');
      if (v.valueMissing) return tekst('prazno');
      if (v.typeMismatch) return pole.type === 'email' ? tekst('imeil') : '';
      var min = pole.min !== '' ? Number(pole.min) : NaN;
      var max = pole.max !== '' ? Number(pole.max) : NaN;
      var vd = vid(pole);
      if (v.rangeUnderflow) return tekst(vd ? vd + '_min' : 'min', { min: chislo(min) });
      if (v.rangeOverflow) return tekst(vd ? vd + '_max' : 'max', { max: chislo(max) });
      if (v.stepMismatch) {
        if (vd === 'broy') return tekst('broy_cyalo');
        var stapka = pole.step && pole.step !== 'any' ? Number(pole.step) : 1;
        var osnova = isFinite(min) ? min : 0;
        var a = osnova + Math.floor((Number(pole.value) - osnova) / stapka) * stapka;
        return tekst('stapka', { a: chislo(a), b: chislo(a + stapka) });
      }
      return '';   // друг вид грешка - остава съобщението на браузъра (в нашите форми няма такава)
    };
    var mahni = function (pole) {
      if (!nashi.has(pole)) return;
      nashi.delete(pole);
      pole.setCustomValidity('');
    };
    var sveri = function (pole) {
      mahni(pole);
      if (!pole.isConnected || !pole.willValidate || pole.validity.valid || pole.validity.customError) return;
      var s = saobshtenie(pole);
      if (!s) return;
      pole.setCustomValidity(s);
      nashi.add(pole);
    };
    var nashe = function (pole) {
      return pole && typeof pole.setCustomValidity === 'function' && !(pole.closest && pole.closest('#octava-checkout-modal'));
    };

    document.addEventListener('invalid', function (e) {
      var pole = e.target;
      if (!nashe(pole)) return;
      pole.addEventListener('invalid', function (ev) {
        if (ev.defaultPrevented) mahni(pole);
        else sveri(pole);
      }, { once: true });
    }, true);

    var chaka = false;
    var sveriVsichki = function () {
      chaka = false;
      Array.from(nashi).forEach(sveri);
    };
    ['input', 'change'].forEach(function (tip) {
      document.addEventListener(tip, function () {
        if (!nashi.size || chaka) return;
        chaka = true;
        setTimeout(sveriVsichki, 0);   // след слушателите на страницата - те може да сменят стойността
      }, true);
    });

    document.addEventListener('click', function (e) {
      if (!nashi.size) return;
      var b = e.target && e.target.closest ? e.target.closest('button, input[type="submit"], input[type="image"]') : null;
      if (!b || !b.form || (b.type !== 'submit' && b.type !== 'image')) return;
      Array.from(nashi).forEach(function (pole) { if (pole.form === b.form) mahni(pole); });
    }, true);
  }
  } catch(e) { console.error(e); }
})();

})();
